import api from './api';

function unwrapPayload(data) {
  if (!data || typeof data !== 'object') return {};
  if (data.data && typeof data.data === 'object') return data.data;
  return data;
}

export const getDashboardStats = async (params = {}) => {
  const query = {};
  if (params.start_date) query.start_date = params.start_date;
  if (params.end_date) query.end_date = params.end_date;
  const response = await api.get('/dashboard/stats', { params: query });
  const payload = unwrapPayload(response.data);
  return {
    stats: payload.stats || {},
    scope: payload.scope || null,
    activeOrganizationId: payload.active_organization_id ?? null,
    isOrganizationAdmin: payload.is_organization_admin ?? null,
  };
};
